<flx-heading size="medium" align="center" type="creation" weight="extra-light">
	{{ title }}
</flx-heading>
<div class="instructions" *ngIf="instructions?.length">
	<p *ngFor="let line of instructions">
		{{ line }}
	</p>
</div>

<div class="company-selection-container">
	@if (isLoading()) {
		<div class="loading-container">
			<flx-loader-component></flx-loader-component>
		</div>
	}

	@if (!isLoading() && visibleCompanies().length > 0) {
		<div class="company-grid" [style.grid-template-columns]="getGridTemplateColumns()">
			@for (company of visibleCompanies(); track company.id) {
				<div
					class="company-cell"
					[class.selected]="isSelected(company.id)"
					role="button"
					tabindex="0"
					[attr.aria-label]="'Select ' + company.name"
					[attr.aria-pressed]="isSelected(company.id)"
					(click)="onCompanySelect(company)"
					(keydown.enter)="onCompanySelect(company)"
					(keydown.space)="onCompanySelect(company); $event.preventDefault()"
				>
					<div class="logo-container">
						<img
							class="company-logo"
							[src]="company.logo_url"
							[alt]="company.logo_alt || company.name"
							loading="lazy"
							(error)="onImageError($event)"
						/>
					</div>
				</div>
			}
		</div>
	}

	@if (!isLoading() && visibleCompanies().length === 0) {
		<div class="empty-state">
			<flx-alert type="info" message="No companies available for selection."></flx-alert>
		</div>
	}
</div>


